var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.83,
    height: 20.821,
    viewBox: "0 0 21.83 20.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13351",
    "data-name": "Group 13351",
    transform: "translate(-2.05 -1.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31920",
    "data-name": "Path 31920",
    d: "M12.3,21.3a9.3,9.3,0,0,0,9.3-9.3H3A9.3,9.3,0,0,0,12.3,21.3Z",
    transform: "translate(0 0.303)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31921",
    "data-name": "Path 31921",
    d: "M7,21H17.336",
    transform: "translate(0.135 0.605)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31922",
    "data-name": "Path 31922",
    d: "M19.5,12.2,22.084,6",
    transform: "translate(0.554 0.101)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31923",
    "data-name": "Path 31923",
    d: "M16.259,3a1.377,1.377,0,0,1,.775,1.406c-.065.858-.962,1.24-1.036,2.088a2.023,2.023,0,0,0,.755,1.674",
    transform: "translate(0.436)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31924",
    "data-name": "Path 31924",
    d: "M11.26,3a1.359,1.359,0,0,1,.765,1.406c-.051.857-.961,1.24-1.013,2.088a1.988,1.988,0,0,0,.743,1.674",
    transform: "translate(0.267)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31925",
    "data-name": "Path 31925",
    d: "M6.259,3a1.377,1.377,0,0,1,.775,1.406C6.97,5.264,6.072,5.646,6,6.493a2,2,0,0,0,.765,1.674",
    transform: "translate(0.101)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodMenuIcon);
export default __webpack_public_path__ + "static/media/food-menu-icon.c39450ae.svg";
export { ForwardRef as ReactComponent };